var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 44,
    viewBox: "0 0 117 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9263 40.005C42.1838 37.7475 43.3125 34.65 43.3125 30.7125V12.6C43.3125 8.6625 42.1838 5.59125 39.9263 3.38625C37.7212 1.12875 34.65 0 30.7125 0H12.6C8.6625 0 5.565 1.12875 3.3075 3.38625C1.1025 5.59125 0 8.6625 0 12.6V30.7125C0 34.65 1.1025 37.7475 3.3075 40.005C5.565 42.21 8.6625 43.3125 12.6 43.3125H30.7125C34.65 43.3125 37.7212 42.21 39.9263 40.005Z",
    fill: "url(#paint0_linear_4675_15169)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5803,
    y: 9.93903,
    width: 10.2596,
    height: 10.9009,
    rx: 5.12982,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5803,
    y: 22.7636,
    width: 10.2596,
    height: 10.9009,
    rx: 5.12982,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7637,
    y: 22.7636,
    width: 10.2596,
    height: 10.9009,
    rx: 5.12982,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9912 33.4063C64.4728 33.6355 63.0223 33.75 61.6398 33.75C60.28 33.75 59.1355 33.2802 58.2063 32.3407C57.2771 31.4011 56.8125 30.1521 56.8125 28.5938V9.34379H62.7617V27.7344C62.7617 28.0782 62.875 28.3646 63.1016 28.5938C63.3283 28.823 63.6115 28.9375 63.9515 28.9375H65.9912V33.4063Z",
    fill: "#0C344E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8445 15.875V33.4063H69.8954V20.5157V15.875H75.8445ZM69.8954 9.00004H75.8445V13.8125H69.8954V9.00004Z",
    fill: "#0C344E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.323 15.1875H97.6121L90.813 33.4063H84.014L77.215 15.1875H83.5041L87.4135 27.5625L91.323 15.1875Z",
    fill: "#0C344E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117 28.25C117 29.9688 116.513 31.3209 115.538 32.3063C114.586 33.2688 113.261 33.75 111.561 33.75H103.742C102.042 33.75 100.705 33.2688 99.7304 32.3063C98.7786 31.3209 98.3026 29.9688 98.3026 28.25V20.3438C98.3026 18.625 98.7786 17.2844 99.7304 16.3219C100.705 15.3365 102.042 14.8438 103.742 14.8438H111.561C113.261 14.8438 114.586 15.3365 115.538 16.3219C116.513 17.2844 117 18.625 117 20.3438V28.25ZM111.051 20.8594C111.051 19.9427 110.598 19.4844 109.691 19.4844H105.612C104.705 19.4844 104.252 19.9427 104.252 20.8594V27.7344C104.252 28.6511 104.705 29.1094 105.612 29.1094H109.691C110.598 29.1094 111.051 28.6511 111.051 27.7344V20.8594Z",
    fill: "#0C344E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4675_15169",
    x1: 21.6562,
    y1: 0,
    x2: 21.6563,
    y2: 43.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8B02"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.02509cebd2922eb7831fc6a58071b768.svg";
export { ForwardRef as ReactComponent };